export const getIcon = (row, customIcon) => {
    switch (row?.method) {
        case 'VIDEO_CALL':
            return customIcon({ title: 'Video Call', icon: 'eva:video-fill' });
        case 'IN_PRACTICE':
            return customIcon({ title: 'In Practice', icon: 'eva:home-fill' });
        default:
            return customIcon({ title: 'Phone', icon: 'eva:phone-fill' });
    }
};

export const StatusValue = (value) => {
    switch (value) {
        case 'CANCELLED':
            return 'Cancelled';
        case 'ATTENDED':
            return 'Attended';
        case 'BOOKED':
            return 'Booked';
        case 'FAILED_TO_ATTEND':
            return 'Failed to attend';
        default:
            return 0;
    }
};

export const getAppointmentCancellationAction = (status, dentally, localState = null, calcom = null) => {
    if (status !== 'BOOKED') {
        return { visible: false, disabled: true, label: '', intent: 'hidden' };
    }

    if (calcom && !calcom.can_cancel) {
        return { visible: true, disabled: true, label: calcom.sync_status === 'pending' ? 'Cal.com change pending' : 'Cal.com cancellation unavailable', intent: 'review' };
    }
    const cancellationState = dentally?.cancellation_state;
    if (dentally?.reconciliation_required || cancellationState === 'UNKNOWN') {
        return { visible: true, disabled: true, label: 'Cancellation needs review', intent: 'review' };
    }
    if (cancellationState === 'CANCELLED') {
        return { visible: false, disabled: true, label: '', intent: 'hidden' };
    }
    if (localState === 'refresh') {
        return { visible: true, disabled: false, label: 'Refresh cancellation status', intent: 'refresh' };
    }
    if (localState === 'refreshing') {
        return { visible: true, disabled: true, label: 'Refreshing cancellation...', intent: 'refresh' };
    }
    if (localState === 'pending' || cancellationState === 'IN_PROGRESS') {
        return { visible: true, disabled: true, label: 'Cancellation pending', intent: 'pending' };
    }
    if (cancellationState === 'PENDING') {
        return { visible: true, disabled: false, label: 'Retry cancellation', intent: 'retry' };
    }
    if (localState === 'retry') {
        return { visible: true, disabled: false, label: 'Refresh cancellation status', intent: 'refresh' };
    }
    return { visible: true, disabled: false, label: 'Cancel', intent: 'cancel' };
};
